import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InviteCrewForm from 'components/event/InviteCrew';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import { createAndInviteUsers, getEligibleMembers } from 'actions/Event';
import { clearModal } from 'actions';
import { Modal, ModalBody } from 'reactstrap';
import { EVENT_INVITE_CREW } from 'constants/ModalTypes';

const InviteEventCrewModal = ({
  event,
  eligibleMembers,
  modalOpen,
  clearModal,
  getEligibleMembers,
  createAndInviteUsers,
  selectedUsers,
}) => {
  useEffect(() => {
    if (modalOpen) {
      getEligibleMembers();
    }
  }, [getEligibleMembers, modalOpen]);

  const clearInviteCrewModal = clearModal.bind(null, EVENT_INVITE_CREW);

  const contentReady = event ? true : false;

  return (
    <Modal isOpen={modalOpen} toggle={clearInviteCrewModal}>
      <StyledModalHeader toggle={clearInviteCrewModal}>
        Invite crew
      </StyledModalHeader>
      <ModalBody>
        {contentReady && (
          <InviteCrewForm
            crewAutoCompleteOptions={eligibleMembers}
            selectedUsers={selectedUsers}
            onSubmit={(users, role) => {
              createAndInviteUsers(users, role);

              clearInviteCrewModal();
            }}
            onCancel={clearInviteCrewModal}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal, event, eventEligibleMembers }) => {
    const props = {
      event,
      eligibleMembers: eventEligibleMembers,
      modalOpen: modal && modal.type === EVENT_INVITE_CREW,
    };

    if (props.modalOpen) {
      return { ...props, ...modal.initialValue };
    }

    return props;
  },
  {
    clearModal,
    getEligibleMembers,
    createAndInviteUsers,
  },
)(InviteEventCrewModal);
